module.exports = __webpack_public_path__ + "assets/img/panels.985c1555.jpg";